<template>
    <select v-model="accidentType">
        <option :value="null">All</option>
        <option value="Accident - EL">Accident - EL</option>
        <option value="Accident - PL">Accident - PL</option>
        <option value="Motor">Motor</option>
        <option value="Other">Other</option>
    </select>
</template>

<script>

    export default {
        name: 'accident-type',
        computed: {
            accidentType: {
                get() {
                    return this.$store.getters['dashboards/accidentType'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'accidentType', value})
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// AccidentType.vue?52d92328